// Use toolkit's combineReducers if you are already using @reduxjs/toolkit
// (It works the same). If you are not, 'redux' combineReducers is fine.
import { combineReducers } from 'redux';

// project imports
import snackbarReducer from './slices/snackbar';
import kanbanReducer from './slices/kanban'; // <-- ADD THIS LINE

// ==============================|| ROOT REDUCER ||============================== //

const reducer = combineReducers({
  kanban: kanbanReducer,     // <-- MOUNT KANBAN HERE (key must be 'kanban')
  snackbar: snackbarReducer
  // add other slices here if you have them (auth, user, etc.)
});

export default reducer;